// extracted by mini-css-extract-plugin
export default {"dropdown":"MoreButton__dropdown___DhQ3n","new":"MoreButton__new___StZiv","active":"MoreButton__active___Mznq5"};